import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { faEllipsisH } from '@fortawesome/free-solid-svg-icons';
import { uniqueIncreasing } from '@utils/utils';
import $ from 'jquery';

@Component({
  selector: 'wsb-buttongroup-renderer',
  template: `
    <a
      *ngIf="!hide"
      class="nav-link"
      (click)="dropdownClick(params.rowIndex, uniqueId)"
      href="#"
      id="atlas-gridgroup-{{ params.rowIndex }}-{{ uniqueId }}"
      role="button"
      data-bs-display="static"
      data-bs-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <wsb-atlas-button
        id="atlas-gridgroup-{{ params.rowIndex }}-{{ uniqueId }}"
        class="mb-2"
        [variant]="'primary'"
        [icon]="faEllipsisH"
      ></wsb-atlas-button>
    </a>
    <div
      class="dropdown dropdown-buttongroup dropdown-menu  dropdown-menu-end"
      style="width: 300px"
      id="atlas-gridgroup-m-{{ params.rowIndex }}-{{ uniqueId }}"
      [attr.aria-labelledby]="'atlas-gridgroup-' + params.rowIndex + '-' + uniqueId"
    >
      <ng-container *ngFor="let item of items; index as i">
        <a class="dropdown-item" *ngIf="!item.hide || !item.hide(params.data)" (click)="item.onClick(params.data, $event)">{{
          item.label | translate
        }}</a>
        <!--              <wsb-atlas-button  class="mb-2 dropdown-item" [variant]="item.variant"-->
        <!--                                (click)="item.onClick" [label]="item.label"></wsb-atlas-button>-->
      </ng-container>
    </div>
    <!--      <ng-content #modalBody select="[body]"></ng-content>-->
    <!--      https://plnkr.co/edit/NDgRCR?p=preview&preview-->
  `,
  standalone: false
})
export class ButtonGroupRendererComponent implements ICellRendererAngularComp {
  params;
  faEllipsisH = faEllipsisH;
  items: any[];
  hide = false;
  uniqueId = uniqueIncreasing();

  agInit(params): void {
    this.params = params;
    this.items = this.params.items;
    this.hide = this.params.hide && this.params.hide instanceof Function ? this.params.hide(params.data) : false;
  }

  refresh(params?: any): boolean {
    return true;
  }

  //
  // destroy?(): void {
  //   $('body > .dropdown').remove();
  // }

  dropdownClick(rowIndex, uniqueId) {
    const grid = $(this.params.eGridCell).parents('wsb-atlas-grid');
    setTimeout(() => {
      if ($('wsb-buttongroup-renderer ' + '#atlas-gridgroup-m-' + rowIndex + '-' + uniqueId).length) {
        // $('body').append($('#atlas-gridgroup-m-' + rowIndex).detach());
        grid.append($('#atlas-gridgroup-m-' + rowIndex + '-' + uniqueId).detach());
      }
    }, 0);
    $('#atlas-gridgroup-m-' + rowIndex + '-' + uniqueId).css({
      position: 'absolute',
      width: '300px',
      left:
        $('#atlas-gridgroup-' + rowIndex + '-' + uniqueId).offset().left -
        grid.offset().left -
        $('#atlas-gridgroup-m-' + rowIndex + '-' + uniqueId).width() +
        63,
      top: $('#atlas-gridgroup-' + rowIndex + '-' + uniqueId).offset().top - grid.offset().top + 50
    });
    // Legacy fix for dropdowns
    // $('wsb-buttongroup-renderer .dropdown').on('show.bs.dropdown', () => {
    // });
  }

  // onClick($event) {
  //   if (this.params.onClick instanceof Function) {
  //     // put anything into params u want pass into parents component
  //     const params = {
  //       event: $event,
  //       rowData: this.params.node.data
  //     };
  //     this.params.onClick(params);
  //   }
  // }
}
